import React, { CSSProperties } from 'react';
import { themeObject, PaginationModel } from '../../lib';
import {
    GridFilterModel,
    GridPaginationModel,
    GridSortModel,
    GridState,
} from '@mui/x-data-grid';
import { TabItemsType } from './components/TabComponent';
import { SxProps } from '@mui/material';

export interface MenuOptionsType {
    label: string;
    icon?: string;
    onClick: () => void;
}

export interface LandingPageWrapperProps {
    title?: string;
    showAddButton?: boolean;
    onAddButtonClick?: () => void;
    showMenuButton?: boolean;
    openMenuItems?: boolean;
    menuStyles?: any;
    handleMenuButtonClick?: () => void;
    menuOptions?: Array<MenuOptionsType>;
    showRefreshButton?: boolean;
    onRefreshButtonClick?: () => void;
    tableData: any;
    isLoading: boolean;
    columns: any;
    getRowId: any;
    onRowClick: (row: any) => void;
    paginationPageSizeOptions: Array<number>;
    paginationPageSize: number;
    emptyStateIcon: string;
    emptyStateHeading?: string;
    emptyStateBodyMessage: React.ReactNode;
    customImageStyles?: CSSProperties;
    customHeadingContainerStyles?: SxProps;
    selectedTab?: any;
    onTabChange?: (event: React.SyntheticEvent, newValue: any) => void;
    setSelectedChain?: React.Dispatch<React.SetStateAction<any>>;
    tabItems?: TabItemsType[];
    tabsContainerStyles?: any;
    tabsStyles?: any;
    tabItemStyles?: any;
    tableHeight?: number;
    rowHeight?: number;
    autoRowHeight?: boolean;
    readonly?: boolean;
    readonlyTooltipTitle?: string;
    isSelectFieldEnabled?: boolean;
    selectedChain?: string;
    isTabAndTableComponentVisible?: boolean;
    isSelectFilterVisible?: boolean;
    selectFilterValue?: any;
    selectFilterStyles?: any;
    selectFilterChildren?: React.ReactNode;
    sortModel?: GridSortModel;
    children?: React.ReactNode;
    rowCount?: number;
    paginationMode?: 'client' | 'server';
    onPaginationModelChange?: React.Dispatch<
        React.SetStateAction<PaginationModel>
    >;
    paginationModel?: GridPaginationModel;
    handleStateChange?: (state: GridState) => void;
    filterModel?: GridFilterModel;
    onFilterModelChange?: (model: GridFilterModel) => void;
}

export const styles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        p: '16px 24px 16px 24px',
    },
    titleAndAddButtonContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& .refresh-icon': {
            color: themeObject.palette.primary[500],
        },
    },
    headingText: {
        fontFamily: 'Raleway',
        fontSize: '28px',
        fontWeight: 600,
        lineHeight: '32.87px',
        color: themeObject.palette.primary[700],
        mr: '4px',
    },
    emptyHeadingText: {
        fontFamily: 'Raleway',
        fontSize: '26px',
        fontWeight: 500,
        lineHeight: '30.52px',
        color: themeObject.palette.primary[700],
    },
    emptySubHeadingText: {
        fontFamily: 'Red Hat Text',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[700],
        textAlign: 'center',
    },
    addButtonStyles: {
        borderRadius: '64px',
        width: '94px',
        height: '40px',
        '& .MuiTypography-root': {
            fontFamily: 'Red Hat Text',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '24px',
            color: themeObject.palette.grayScale[700],
            ml: '2px',
        },
    },
    tabsContainer: {
        mt: 2.5,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    selectFieldStyles: {
        width: '220px',
        height: '40px',
    },
    selectFieldHeightStyles: {
        maxHeight: '240px',
    },
    menuStyles: {
        '& .MuiMenu-paper': {
            width: '200px',
            display: 'flex',
            flexDirection: 'row',
            borderRadius: '15px',
            mt: '1px',
            '& .MuiMenu-list': {
                width: '100%',
            },
        },
    },
    menuItemStyles: {
        width: '100%',
        pt: 1,
        pb: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    menuItemTextStyles: {
        ...themeObject.typography.Components.menuItem,
        lineHeight: '27px',
        color: themeObject.palette.grayScale[800],
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
};
